// Časovač slouží pro zablokování tlačítek,

// Interval 120 koresponduje se současným nastavením BE
const intervalInSeconds = 120;
const TEXT_BUTTON = 'Odeslat komentář';

// Změnit stav tlačítka | text / disabled / class
interface ToggleDisabledButtonsAddCommentProps {
  className?: string;
  disabled?: boolean;
  innerText?: string;
}
const updateButtonsAddComment = ({
  className = 'button--pending',
  disabled = true,
  innerText = TEXT_BUTTON,
}: ToggleDisabledButtonsAddCommentProps = {}) => {
  // Nelze načíst z elementů - querySelectorAll musí znova projít dokument, protože mohl být naklonován formulář pro odpověď
  const buttons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('[data-add-comment]');
  if (buttons.length)
    buttons.forEach((button: HTMLButtonElement) => {
      // Nastavit popisek tlačítka
      button.innerHTML = innerText;
      if (innerText !== TEXT_BUTTON) {
        return;
      }

      // Změnit stav tlačítka
      button.disabled = disabled;

      // Prohodit class
      if (disabled) button.classList.add(className);
      else button.classList.remove(className);
    });
};

interface ForumTimerProps {
  init?: boolean;
  componentName?: string;
  buttonInfoText?: boolean;
}
export const forumTimer = ({
  init = false,
  componentName = 'cncForum',
  buttonInfoText = true,
}: ForumTimerProps = {}) => {
  // Načíst proměnné z localStorage
  const keyStart = `${componentName}StartTime`;
  const keyEnd = `${componentName}EndTime`;
  let startTime = localStorage.getItem(keyStart);
  let timeLeft = localStorage.getItem(keyEnd);

  if (!startTime || Date.now() - Number(startTime) > Number(timeLeft) * 1000) {
    // Spustit časovač
    if (init) {
      startTime = String(Date.now());
      timeLeft = String(intervalInSeconds);
      // Nastavit tlačítka jako disabled
      updateButtonsAddComment();
    } else return;
  }

  // Pokud timer už běží (včetně momentu po refreshi)
  if (timeLeft && Number(timeLeft) > 0) {
    // Nastavit tlačítka jako disabled
    updateButtonsAddComment();
  }

  // Každou vteřinu
  const timer = setInterval(() => {
    // Vypočítat čas, který uplynul od spuštění časovače
    const elapsed = Math.floor((Date.now() - Number(startTime)) / 1000);

    // Aktualizovat zbývající čas
    timeLeft = String(Math.max(0, Number(timeLeft) - elapsed));

    // Pokud se odečítá čas, upravit obsah tlačítek
    if (Number(timeLeft) > 0 && buttonInfoText)
      updateButtonsAddComment({
        innerText: `<span>${timeLeft.toString()}s do dalšího komentáře</span>`,
      });

    // Pokud interval vyprší
    if (Number(timeLeft) <= 0) {
      // Vymazat interval
      clearInterval(timer);

      // Aktivovat všechna tlačítka
      updateButtonsAddComment({ disabled: false });

      // Vyčistit úložiště
      localStorage.removeItem(keyStart);
      localStorage.removeItem(keyEnd);
    } else {
      // Do úložiště přidat 'startTime', 'timeLeft'
      if (startTime) localStorage.setItem(keyStart, startTime);
      localStorage.setItem(keyEnd, timeLeft);

      // Aktualizovat čas zahájení, aby zohlednil uplynulý čas
      startTime = String(Number(startTime) + elapsed * 1000);
    }
  }, 1000);
};
